import { render } from "./bookdemo.vue?vue&type=template&id=7f6102ee"
import script from "./bookdemo.vue?vue&type=script&lang=js"
export * from "./bookdemo.vue?vue&type=script&lang=js"

import "./bookdemo.vue?vue&type=style&index=0&id=7f6102ee&lang=css"
script.render = render

export default script